<template>
  <div
    class="sd-tool-item sd-flex"
    :class="{ 'hover-tool-item': enter_ }"
    v-if="data"
    :title="data.name"
    @click="data.click"
    @mouseenter="handleMouseEnter"
    @mouseleave="handleMouseLeave"
  >
    <svg-icon :icon-class="data.icon ? data.icon : 'warning-gray'" style="width: 25px; height: 25px"></svg-icon>
  </div>
</template>

<script>
export default {
  props: {
    data: {
      type: Object,
      default() {
        return {
          name: null,
          icon: null,
          click: null,
        }
      },
    },
  },
  data() {
    return {
      enter_: false,
      fontWidth_: 0,
    }
  },
  watch: {
    data() {
      this.initParameter()
    },
  },
  mounted() {
    this.initParameter()
  },
  methods: {
    handleMouseEnter() {
      this.enter_ = true
    },
    handleMouseLeave() {
      this.enter_ = false
    },
    getFontWidth() {
      return 'width:' + this.fontWidth_ + 'px;'
    },
    initParameter() {
      this.fontWidth_ = this.data.name ? this.data.name.length * 16 + 10 : 40
    },
  },
}
</script>

<style scoped>
.sd-tool-item {
  background-color: white;
  padding: 5px;
  border-radius: 35px;
  box-shadow: 0 0 10px #b9b3b3;
  margin: 15px;
}
.hover-tool-item {
  box-shadow: 0 0 10px orange !important;
}
.sd-tool-item .tool-name {
  padding: 0 5px;
}
</style>
